import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SubsectionInFrame from '../../misc/SubsectionInFrame';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { getAppLanguage } from '../../../intl/languages';

////////////////////////////////////////////
// TODO missing tests - rendering problem
//Invariant Violation: `Relay(injectIntl(MediaListItem))` tried to render a context that was not valid this means that `Relay(injectIntl(MediaListItem))` was rendered outside of a query renderer.
////////////////////////////////////////////

const MediaListInfoTile = (props) => {
  const { onClick, type } = props;
  const [startAnimate, setStartAnimate] = useState(false);
  const animatedElementRef = useRef();

  const linkToFAQForAlternativeSearchHint = (
    <a
      href={`https://helpdesk.sportograf.com/${getAppLanguage()}/support/solutions/articles/77000265399`}
      target="_blank"
      rel="noopener noreferrer"
      className="link-blue-underline"
    >
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.alternativeSearchHint.link"
        defaultMessage="Learn more"
      />
    </a>
  );

  const handleScroll = useCallback(() => {
    if (
      animatedElementRef.current?.getBoundingClientRect().top +
        animatedElementRef.current?.parentNode?.offsetTop <=
      window.innerHeight + window.scrollY
    ) {
      setStartAnimate(true);
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  useEffect(() => {
    if (
      animatedElementRef.current?.getBoundingClientRect().top +
        animatedElementRef.current?.parentNode?.offsetTop <=
      window.innerHeight - 100
    ) {
      setStartAnimate(true);
    } else {
      window.addEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  const recheckShowOrderTexts = {
    header: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOrder.heading"
        defaultMessage="What now?"
        className="typography uppercase typography-title_small"
      />
    ),
    description: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOrder.description"
        defaultMessage="Approved images have been added to your Foto-Flat. Go to your order and download them all or click on the photo here, to download a single photo directly."
      />
    ),
    buttonText: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOrder.button"
        defaultMessage="Go to order"
      />
    ),
  };

  const recheckPendingTexts = {
    header: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckPending.heading"
        defaultMessage="We are on it"
        className="typography uppercase typography-title_small"
      />
    ),
    description: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckPending.description"
        defaultMessage="After we reviewed your request, we will notify you by email. Please be patient."
      />
    ),
    buttonText: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckPending.button"
        defaultMessage="Learn more"
      />
    ),
  };

  const recheckShowOfferTexts = {
    header: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOffer.heading"
        defaultMessage="Foto-Flat"
        className="typography uppercase typography-title_small"
      />
    ),
    description: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOffer.description"
        defaultMessage="offer"
      />
    ),
    buttonText: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.recheckOffer.button"
        defaultMessage="Show offer"
      />
    ),
  };

  const alternativeSearchHintTexts = {
    header: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.alternativeSearchHint.heading"
        defaultMessage="How to buy?"
        className="typography uppercase typography-title_small"
      />
    ),
    description: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.alternativeSearchHint.description"
        defaultMessage="You are in search results for other search options. {link}."
        values={{
          link: linkToFAQForAlternativeSearchHint,
        }}
      />
    ),
    additionalInstruction: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.alternativeSearchHint.descriptionMainSearchWasUsed"
        defaultMessage="Click below to go back to your personal Foto-Flat offer."
      />
    ),
    buttonText: (
      <FormattedMessageWrappedInSpan
        id="mediaListInfoTile.alternativeSearchHint.buttonToGoBackToPhotos"
        defaultMessage="Go to offer"
      />
    ),
  };

  const defineTileTexts = () => {
    switch (type) {
      case 'alternativeSearchHint':
        return alternativeSearchHintTexts;
      case 'recheckShowOrder':
        return recheckShowOrderTexts;
      case 'recheckShowOffer':
        return recheckShowOfferTexts;
      case 'recheckPending':
        return recheckPendingTexts;
    }
  };

  return (
    <div className="subsection-full-width-sm" ref={animatedElementRef}>
      <SubsectionInFrame
        color="light"
        actionable={true}
        title={defineTileTexts().header}
        headerStyle="narrow"
        className={classNames('subsection-animated', {
          'subsection-animated_start': startAnimate,
        })}
      >
        <div className="subsection-item">{defineTileTexts().description}</div>
        {defineTileTexts().additionalInstruction && (
          <div className="subsection-item">{defineTileTexts().additionalInstruction}</div>
        )}

        <button
          onClick={() => {
            onClick();
          }}
          className="subsection-action-button btn-in-media-list primary-new subsection-action-button_small"
        >
          {defineTileTexts().buttonText}
        </button>
      </SubsectionInFrame>
    </div>
  );
};

MediaListInfoTile.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf([
    'alternativeSearchHint',
    'recheckShowOrder',
    'recheckShowOffer',
    'recheckPending',
  ]),
};

export default MediaListInfoTile;
